import React, {
    useState,
    useEffect,
} from 'react'

import {
    FontAwesomeIcon,
} from "@fortawesome/react-fontawesome";

import {
    faCheck,
    faQuestion,
} from "@fortawesome/free-solid-svg-icons";

import { PDFDownloadLink } from "@react-pdf/renderer";
import { PDFDocument } from "../../../components/pdfIndividual";

import {
    Text,
    Container,
    ToggleButton,
    TextInput,
    ComboBox,
    Button,
    Checkbox,
    DataTable,
    SideModal,
    Pagination,
} from '../../../components';

import {
    KeyValue,
} from '../../../types/subTypes';

import pdfMock from '../../../utils/pdfMock.json';

import * as s from './formEficienciaReprodutiva.module.css'

export const FormEficienciaReprodutiva: React.FC = () => {
    type keysTab = 'serie' | 'rgd' | 'outras';

    interface tabButton {
        key: keysTab,
        content: string,
    };

    const tabs: tabButton[] = [
        {
            key: 'serie',
            content: 'Série única',
        },

        {
            key: 'rgd',
            content: 'RGD',
        },

        {
            key: 'outras',
            content: 'Outras opções',
        },
    ];

    const infos = [
        '- Poderá ser emitido atestado individual de eficiência reprodutiva, e também emitir um relatório com diversas matrizes.',
        '- Os animais devem ser de sua propriedade.',
        '- Será gerado um código de autenticação para cada estado emitido.',
        '- As informações sçao extraídas na data da emissão, consequentemente podem sofrer alterações posteriores, send necessário emissção de novo atestado.',
        '- Para emitir um atestado individual ou um relatório, informe abaixo os dados dos animais.',
        '- O intervalo de datas utilizados para filtros refere-se a data de perição de vaca.',
    ];

    const tableColumnsRaca: KeyValue[] = [
        {
            key: 'nome',
            value: 'Nome',
        },

        {
            key: 'rg',
            value: 'RG',
        },

        {
            key: 'raca',
            value: 'Raça',
        },

        {
            key: 'categoria',
            value: 'Cat.',
        },

        {
            key: 'sexo',
            value: 'Sexo',
        },

        {
            key: 'nascimento',
            value: 'Nascimento',
        },
    ];

    const tableColumns: KeyValue[] = [
        {
            key: 'serie',
            value: 'Série/RGN/RG',
        },

        {
            key: 'sexo',
            value: 'Sexo',
        },

        {
            key: 'nome',
            value: 'Nome',
        },

        {
            key: 'nascimento',
            value: 'Nascimento',
        },

        {
            key: 'peso',
            value: 'Peso (205/210)',
        },

        {
            key: 'irgc',
            value: 'IRGC (205/210)',
        },

        {
            key: 'tipoParto',
            value: 'Tipo de Parto',
        },

        {
            key: 'idadeParto',
            value: 'Idade do Parto',
        },

        {
            key: 'situacao',
            value: 'Situação',
        },

        {
            key: 'rgPai',
            value: 'RG Pai',
        },

        {
            key: 'nomePai',
            value: 'Nome Pai',
        },
    ];

    const [selectedTab, setSelectedTab] = useState<tabButton>(tabs[0]);

    const [result, setResult] = useState<any>(null);
    const [fichaReprodutiva, setFichaReprodutiva] = useState<any>(null);

    const [openModal, setOpenModal] = useState<boolean>(false);

    const [ pdfData, setPdfData ] = useState<any>( null );

    useEffect(() => {
        setPdfData( pdfMock );
    }, [ pdfMock ]);

    return (
        <div className={s.container}>
            {
                fichaReprodutiva
                    ?   <>
                            <div className={s.row}>
                                <Text
                                    innerText="Ficha reprodutiva"
                                    variation="heading"
                                />

                                {
                                    pdfData &&
                                    <PDFDownloadLink
                                        document={
                                        <PDFDocument
                                            { ...pdfData }
                                        />
                                        }
                                        fileName="Ficha Animal Individual"
                                    >
                                        {({ blob, url, loading, error }) => (
                                        loading
                                            ? <span>Gerando PDF...</span>
                                            : <Button
                                                content="Imprimir"
                                                type="button"
                                            />
                                        )}
                                    </PDFDownloadLink>
                                }
                            </div>

                            <div className={s.row}>
                                <div className={ s.content }>
                                    <Container
                                        title="Identificação do animal"
                                        titleVariant="contained"
                                    >
                                        <div className={s.row}>
                                            <Text
                                                innerText="Nome:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Rabda RMVC"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Sexo:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Fêmea"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="RG:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="21"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Raça:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Nelore"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Nascimento:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="12/12/2000"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Categoria:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="PO"
                                                variation="normal"
                                            />
                                        </div>
                                    </Container>
                                </div>

                                <div className={ s.content }>
                                    <Container
                                        title="Pais"
                                        color="secondary"
                                        titleVariant="contained"
                                    >
                                        <div className={s.row}>
                                            <Text
                                                innerText="Pai:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Mais Fia"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Mãe:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Liberdade"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Criador:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Luciano Ribeiro"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Proprietário:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Jairo Machado"
                                                variation="normal"
                                            />
                                        </div>
                                    </Container>

                                    <br />

                                    <Container
                                        title="Fazenda"
                                        titleVariant="contained"
                                    >
                                        <div className={s.row}>
                                            <Text
                                                innerText="Fazenda:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Vera Cruz"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="UF:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="MT"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={s.row}>
                                            <Text
                                                innerText="Municício:"
                                                variation="normal"
                                            />

                                            <Text
                                                innerText="Barra dos graças"
                                                variation="normal"
                                            />
                                        </div>
                                    </Container>
                                </div>
                            </div>

                            <Container
                                title="Identificação do animal"
                                titleAlign="left"
                            >
                                <div className={ s.rowContainer }>
                                    <div className={ s.item }>
                                        <div className={ s.row }>
                                            <Text
                                                innerText="Idade: 9,5 anos em 21/01/2021"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Idade no último parto - IDUP: 8,2 anos"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Idade ao primeiro parto - IPP: 26,7 meses (melhor 36 < meses)"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Número total de filhos: 2"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Número total de filhos com RGN: 3"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Números de parto como receptora: 42"
                                                variation="normal"
                                            />
                                        </div>
                                    </div>

                                    <div className={ s.item }>
                                        <div className={ s.row }>
                                            <Text
                                                innerText="Número de partos: 42"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Número de filhos com PC 210 dias: 2"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Intervalo entre partos médio - IEP: 72 dias"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Precocidade Rusticidade Sobrevivência - PRS: (melhor > 100)"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Eficiência Reprodutiva ER: (melhor > 100)"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Habilidade Materna mais Provável HMMP:  (melhor > 100)"
                                                variation="normal"
                                            />
                                        </div>
                                    </div>

                                    <div className={ s.item }>
                                        <div className={ s.row }>
                                            <Text
                                                innerText="Índice de produtividade - IPT: (melhor > 100)"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Última CDC: 12/10/2021 Tipo A"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Data do primeiro parto: 12/10/2021"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Data do último parto: 12/10/2021"
                                                variation="normal"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Container>
                            
                            <br />

                            <Container
                                title="CDP - Controle de desenvolvimento ponderal da matriz"
                                titleAlign="left"
                            >
                                <div className={ s.rowContainer }>
                                    <div className={ s.item }>
                                        <div className={ s.row }>
                                            <Text
                                                innerText="PC (205/210): 197"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Classificação: S"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="PC 365: 308"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Classificação: R"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="PC (450/550): 450"
                                                variation="normal"
                                            />
                                        </div>

                                        <div className={ s.row }>
                                            <Text
                                                innerText="Classificação: R"
                                                variation="normal"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Container>

                            <br />

                            <DataTable
                                columns={tableColumns}
                                items={[
                                    {
                                        serie: 'FVC/10205/10105',
                                        sexo: 'M',
                                        nome: 'Meneio FVC',
                                        nascimento: '10/11/2014',
                                        peso: '235',
                                        irgc: '106.1 S',
                                        tipoParto: 'Natural',
                                        idadeParto: '22.94 M',
                                        situacao: 'Controlado',
                                        rgPai: 'RDM 4196',
                                        nomePai: 'Maximus',
                                    }
                                ]}
                            />

                            <div className={ s.row }>
                                <Button
                                    content="Voltar"
                                    type="button"
                                    onClick={() => setFichaReprodutiva(null)}
                                />

                                <Pagination
                                    count={ 3 }
                                    onChange={() => {}}
                                    page={ 2 }                                    
                                />
                            </div>
                        </>
                    : <>
                        <Text
                            innerText="Tipo de pesquisa"
                            variation="heading"
                        />

                        <div className={s.actions}>
                            <div className={s.tabAction}>
                                {
                                    tabs.map((button: tabButton) =>
                                        <ToggleButton
                                            key={button.key}
                                            content={button.content}
                                            toggled={button.key === selectedTab.key}
                                            onClick={() => setSelectedTab(button)}
                                        />
                                    )
                                }
                            </div>

                            {
                                result &&
                                <div className={s.rightactions}>
                                    <Button
                                        content="Nova busca"
                                        type="button"
                                        onClick={() => setResult(null)}
                                    />
                                </div>
                            }
                        </div>

                        {
                            result
                                ? <>
                                    <Container
                                        title="Filtros pesquisados"
                                        titleAlign="left"
                                    >
                                        <div className={s.row}>
                                            <div className={s.column}>
                                                <div className={s.row}>
                                                    <div className={s.item}>
                                                        <Text
                                                            innerText={`Fazenda: ${1}`}
                                                            variation="normal"
                                                        />
                                                    </div>

                                                    <div className={s.item}>
                                                        <Text
                                                            innerText={`Categoria: ${'PO'}`}
                                                            variation="normal"
                                                        />
                                                    </div>

                                                    <div className={s.item}>
                                                        <Text
                                                            innerText={`Ativas: ${'Sim'}`}
                                                            variation="normal"
                                                        />
                                                    </div>
                                                </div>

                                                <div className={s.row}>
                                                    <div className={s.item}>
                                                        <Text
                                                            innerText={`Raça: ${'Nelore'}`}
                                                            variation="normal"
                                                        />
                                                    </div>

                                                    <div className={s.item}>
                                                        <Text
                                                            innerText={`Sexo: ${'Femea'}`}
                                                            variation="normal"
                                                        />
                                                    </div>

                                                    <div className={s.item}>
                                                        <Text
                                                            innerText={`Primioaras: ${'Não selecionado'}`}
                                                            variation="normal"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={s.column}>
                                                <div className={s.rowButtons}>
                                                    <Button
                                                        content="Relatório Detalhado sem Filho"
                                                        type="button"
                                                    />

                                                    <Button
                                                        content="Exportar Excel sem Filho"
                                                        type="button"
                                                        outlined
                                                    />
                                                </div>

                                                <div className={s.rowButtons}>
                                                    <Button
                                                        content="Relatório Detalhado sem Filho"
                                                        type="button"
                                                    />

                                                    <Button
                                                        content="Exportar Excel sem Filho"
                                                        type="button"
                                                        outlined
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Container>

                                    <br />

                                    <DataTable
                                        title={`Raça selecionada: ${'Nelore'}`}
                                        columns={tableColumnsRaca}
                                        items={[
                                            {
                                                nome: 'RABDA RMVC',
                                                rg: 'RMVC3',
                                                raca: 'Nelore',
                                                categoria: 'PO',
                                                sexo: 'F',
                                                nascimento: '03/07/2011',
                                            }
                                        ]}
                                        rowButtonText="Ver"
                                        rowButtonAction={() => setFichaReprodutiva({})}
                                        headerButtonContent={<FontAwesomeIcon icon={faQuestion} />}
                                        headerButtonAction={() => setOpenModal(true)}
                                    />
                                </>
                                : <div className={s.contents}>
                                    <div className={s.content}>
                                        <Container title="Buscar Animal">
                                            {
                                                selectedTab.key === 'serie' &&
                                                <>
                                                    <Text
                                                        innerText="Série única"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Série"
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="RGN"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="RGN Inicial"
                                                            width={245}
                                                        />

                                                        <span>até</span>

                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="RGN Final"
                                                            width={245}
                                                        />
                                                    </div>
                                                </>
                                            }

                                            {
                                                selectedTab.key === 'rgd' &&
                                                <>
                                                    <Text
                                                        innerText="Raça"
                                                        variation="heading"
                                                    />

                                                    <div className={s.rowCombobox}>
                                                        <ComboBox
                                                            value="Brahman"
                                                            placeholder="Raça"
                                                            displayName="value"
                                                            items={[
                                                                {
                                                                    key: 'brahman',
                                                                    value: 'Brahman'
                                                                }
                                                            ]}
                                                            handleInput={() => { }}
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="Categoria"
                                                        variation="heading"
                                                    />

                                                    <div className={s.rowCombobox}>
                                                        <ComboBox
                                                            value="PO"
                                                            placeholder="Categoria"
                                                            displayName="value"
                                                            items={[
                                                                {
                                                                    key: 'po',
                                                                    value: 'PO'
                                                                }
                                                            ]}
                                                            handleInput={() => { }}
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="Sexo"
                                                        variation="heading"
                                                    />

                                                    <div className={s.rowCombobox}>
                                                        <ComboBox
                                                            value="Fêmea"
                                                            placeholder="Sexo"
                                                            displayName="value"
                                                            items={[
                                                                {
                                                                    key: 'F',
                                                                    value: 'Fêmea'
                                                                }
                                                            ]}
                                                            handleInput={() => { }}
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="RGN"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="RGN Inicial"
                                                            width={245}
                                                        />

                                                        <span>até</span>

                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="RGN Final"
                                                            width={245}
                                                        />
                                                    </div>
                                                </>
                                            }

                                            {
                                                selectedTab.key === 'outras' &&
                                                <>
                                                    <Text
                                                        innerText="Pesquisa por animal"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Mês"
                                                            width={115}
                                                        />

                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Ano"
                                                            width={115}
                                                        />

                                                        <span>até</span>

                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Mês"
                                                            width={115}
                                                        />

                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Ano"
                                                            width={115}
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="Detalhes do animal"
                                                        variation="heading"
                                                    />

                                                    <div className={s.rowCombobox}>
                                                        <ComboBox
                                                            value="Vera Cruz"
                                                            placeholder="Fazenda"
                                                            items={[
                                                                {
                                                                    key: 1,
                                                                    value: 'Vera Cruz'
                                                                }
                                                            ]}
                                                            handleInput={() => { }}
                                                            displayName="value"

                                                        />

                                                        <ComboBox
                                                            value="Brahman"
                                                            placeholder="Raça"
                                                            items={[
                                                                {
                                                                    key: 1,
                                                                    value: 'Brahman'
                                                                }
                                                            ]}
                                                            handleInput={() => { }}
                                                            displayName="value"
                                                        />

                                                        <ComboBox
                                                            value="PO"
                                                            placeholder="Categotia"
                                                            items={[
                                                                {
                                                                    key: 1,
                                                                    value: 'PO'
                                                                }
                                                            ]}
                                                            handleInput={() => { }}
                                                            displayName="value"
                                                        />

                                                        <ComboBox
                                                            value="Fêmea"
                                                            placeholder="Sexo"
                                                            items={[
                                                                {
                                                                    key: 1,
                                                                    value: 'Fêmea'
                                                                }
                                                            ]}
                                                            handleInput={() => { }}
                                                            displayName="value"
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="Vagas ativas"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <Checkbox
                                                            checked={true}
                                                            text="Com filhos nos últimos 3 anos (Período será desconsiderado)"
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="Vagas primipares"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <Checkbox
                                                            checked={true}
                                                            text="Com apenas 1 parto (Exceto FIV/TE"
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="Idade da matriz (em meses)"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Inicial"
                                                            width={195}
                                                        />

                                                        <span>até</span>

                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Final"
                                                            width={195}
                                                        />
                                                    </div>

                                                    <Text
                                                        innerText="Útimo parto (mínimo de meses)"
                                                        variation="heading"
                                                    />

                                                    <div className={s.row}>
                                                        <TextInput
                                                            onChange={() => { }}
                                                            placeholder="Quantidade"
                                                            width={195}
                                                        />
                                                    </div>
                                                </>
                                            }

                                            <div className={s.contentActions}>
                                                <Button
                                                    content="Pesquisar"
                                                    type="button"
                                                    onClick={() => setResult({})}
                                                />
                                            </div>
                                        </Container>
                                    </div>

                                    <div className={s.content}>
                                        <Container title="Tipo de atestado">
                                            {
                                                infos.map((info, index) =>
                                                    <div
                                                        key={index}
                                                        className={s.textRow}
                                                    >

                                                        <FontAwesomeIcon icon={faCheck} color="#7a3fc7" />

                                                        <Text
                                                            innerText={info}
                                                            variation="normal"
                                                        />
                                                    </div>
                                                )
                                            }
                                        </Container>
                                    </div>
                                </div>
                        }
                    </>
            }

            {
                openModal &&
                <SideModal
                    title="Ajuda"
                    position="right"
                    width={415}
                    closeFunction={() => setOpenModal(false)}
                    text="
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident optio recusandae corporis accusantium odio corrupti officia, ab ipsam, ratione reiciendis illum modi reprehenderit commodi nisi, impedit velit est ea facilis.
                            Molestiae ipsa ipsam pariatur. Atque aliquid vero fugit consequuntur eligendi quos quis deserunt, explicabo odio omnis officia a ad. Repudiandae distinctio commodi quas magni nesciunt hic non explicabo ipsum eos?
                            Harum eius inventore quod labore totam tempora rerum, expedita laborum est laboriosam quisquam nemo beatae odio quia, aliquid dolor? Repellendus doloremque fugit labore! Doloremque beatae enim explicabo debitis commodi aut.
                            Numquam id, inventore alias blanditiis ad magnam corporis. At natus harum placeat blanditiis, ducimus ratione officia culpa nesciunt labore vitae inventore consectetur delectus debitis nihil voluptatem tenetur explicabo iure non?
                            A vero atque magni voluptas aliquam nisi fugit aliquid soluta. Id dignissimos pariatur nobis vitae, itaque velit consectetur debitis inventore non cumque est nesciunt minus tempora. Sunt excepturi impedit cum!
                            Cupiditate hic nam deleniti est porro dolor, necessitatibus blanditiis repudiandae! Placeat vero quisquam, id sequi ea dolore est eos voluptates qui nobis inventore corporis! Hic sed dolor dolorem reiciendis doloremque.
                            Illo unde nam similique sint aliquam voluptatem minus. Saepe, fugiat harum doloribus facere laboriosam, tempora suscipit quae nisi tenetur possimus velit nostrum quam eum deleniti esse accusantium laborum. Reiciendis, doloremque?
                            Nobis maiores hic nemo, veritatis reprehenderit quaerat laboriosam aperiam tempore quia culpa aliquam inventore debitis et nostrum molestiae quis! Ipsa voluptatum pariatur omnis commodi! Ipsum ducimus adipisci iusto quod mollitia!
                        "
                />
            }
        </div>
    );
}